import { render } from "./EditUnitComponent.vue?vue&type=template&id=ed4e94ca&scoped=true"
import script from "./EditUnitComponent.vue?vue&type=script&lang=js"
export * from "./EditUnitComponent.vue?vue&type=script&lang=js"

import "./EditUnitComponent.vue?vue&type=style&index=0&id=ed4e94ca&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed4e94ca"]])

export default __exports__